/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Header scrolling hide/show
document.addEventListener('DOMContentLoaded', () => {
  let lastScrollY = window.scrollY;
  const wrapper = document.querySelector('.shopify-section__header');

  if (!wrapper) return;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    const scrollDelta = Math.abs(currentScrollY - lastScrollY);

    // Only trigger if scroll movement is significant (>5px) to prevent flickering
    if (scrollDelta > 5) {
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        wrapper.classList.add('header-wrapper--collapsed');
      } else if (currentScrollY < lastScrollY) {
        wrapper.classList.remove('header-wrapper--collapsed');
      }
      lastScrollY = currentScrollY;
    }
  });
});

const header = document.querySelector('.header');
const root = document.documentElement;

function updateHeaderHeight() {
  const height = header.offsetHeight;
  root.style.setProperty('--header-height', height + 'px');
}

updateHeaderHeight();
window.addEventListener('resize', updateHeaderHeight);

// Fix search results and nav-bar layer issue
const searchWrapper = document.querySelector('.header__search-bar-wrapper');
const wrapper = document.querySelector('.shopify-section__header');

const observer = new MutationObserver(() => {
  if (searchWrapper.classList.contains('is-fixed')) {
    wrapper.classList.add('search-active');
  } else {
    wrapper.classList.remove('search-active');
  }
});

observer.observe(searchWrapper, { attributes: true, attributeFilter: ['class'] });